import Reveal from "@/components/feature/Reveal";
import { relatedServices } from "@/mocks/home";

export default function RelatedServicesSection() {
  return (
    <section id="related-services" className="border-y border-background-200/70 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="text-center">
          <p className="font-label text-[36px] font-bold tracking-[0.15em] text-foreground-700 md:text-[40px]">
            RELATED SERVICE
          </p>
          <h2 className="mt-3 font-heading text-4xl font-black leading-tight text-foreground-950 md:text-7xl">
            関連サービス
          </h2>
          <p className="mx-auto mt-4 max-w-2xl font-body text-sm leading-relaxed text-foreground-600 md:text-base">
            人材と組織の課題に合わせて、ナンバが提供する専門サービスをご紹介します。各カードから専用サイトへお進みいただけます。
          </p>
          <p className="mx-auto mt-3 flex items-center justify-center gap-1.5 font-body text-xs text-foreground-500 md:text-sm">
            <i className="ri-information-line text-sm" />
            ※ 各サービスは提携サイトでご案内しています
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 md:mt-14 md:gap-6">
          {relatedServices.map((service, index) => (
            <Reveal key={service.label} delay={index * 120} className="h-full">
              <div
                className="group relative flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1.5 hover:border-primary-300 hover:bg-primary-50"
              >
                <div className="relative h-40 w-full overflow-hidden border-b border-background-200 bg-background-100 md:h-44">
                  <img
                    src={service.image}
                    alt={`${service.label}のイメージ`}
                    title={`ナンバ 関連サービス ${service.label}`}
                    className="h-full w-full object-cover object-top"
                  />
                  <span className="absolute right-3 top-3 rounded-full bg-background-50/90 px-3 py-1 font-label text-xs font-bold tracking-wide text-secondary-900 backdrop-blur-sm">
                    {service.label}
                  </span>
                </div>

                <div className="flex flex-1 flex-col p-6 md:p-7">
                  <div className="flex items-center gap-3">
                    <span className="flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                      <i className={`${service.icon} text-2xl`} />
                    </span>
                    <h3 className="whitespace-pre-line font-heading text-lg font-black leading-snug text-foreground-950 md:text-xl">
                      {service.title}
                    </h3>
                  </div>
                  <p className="mt-3 flex-1 font-body text-sm leading-relaxed text-foreground-600">
                    {service.description}
                  </p>

                  {service.href ? (
                  <div className="mt-6 flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
                    <span className="inline-flex items-center gap-1.5 font-label text-sm font-bold text-primary-600 transition-colors group-hover:text-primary-700">
                      {service.cta}
                      <i className="ri-arrow-right-up-line text-lg" />
                    </span>

                    <p className="flex items-center gap-1.5 font-body text-xs text-foreground-500">
                      <i className="ri-external-link-line text-sm" />
                      提携サイトへ移動します
                    </p>
                  </div>
                  ) : null}
                </div>
                {service.href ? (
                  <a href={service.href} target="_blank" rel="noopener noreferrer" className="absolute inset-0" aria-label={`${service.title} 詳しく見る`} />
                ) : null}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}